<template>
  <v-list-item class="list-toggler hover-list-element text-body-2" @click="computedValue = !computedValue">
    <v-list-item-content>
      <v-list-item-title class="list-toggler-text text-body-2">
        {{ computedValue ? toggleOffTitle : toggleOnTitle }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  name: 'ListToggler',
  props: {
    toggleOnStraightTitle: {
      type: String,
    },
    toggleOffStraightTitle: {
      type: String,
    },
    toggleOnTranslationPath: {
      type: String,
      default: 'featureCard.seeMore',
    },
    toggleOffTranslationPath: {
      type: String,
      default: 'featureCard.seeLess',
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    toggleOnTitle() {
      return this.toggleOnStraightTitle || this.$i18n.t(this.toggleOnTranslationPath);
    },
    toggleOffTitle() {
      return this.toggleOffStraightTitle || this.$i18n.t(this.toggleOffTranslationPath);
    },
  },
};
</script>
<style lang="scss" scoped>
.list-toggler {
  min-height: 36px;
  max-height: 36px;
}
.list-toggler-text {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.5) !important;
}
</style>
